// extracted by mini-css-extract-plugin
export default {"empty":"empty__G8apL","small":"small__ESH8N","empty__icon":"empty__icon__Mp14V","medium":"medium__TUZ0n","empty__label":"empty__label__tWYfI"};